var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('router-view',{attrs:{"contract":_vm.contract,"reports":_vm.reports},on:{"FETCH_DATA":function($event){return _vm.handleFetchData()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }